<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-if="showForm" v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Agency Name"
                v-model="formSchema.dev_partner_name"
                :rules="[v => !!v || 'Agency Name is required !',lng100]"
                required
              ></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Short Name"
                v-model="formSchema.in_short"
                :rules="[v => !!v || 'In short is required !',lng10]"
                required
              ></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Implement Agency Type"
                v-model="formSchema.dev_partner_type"
                :rules="[v => !!v || 'Implement agency type is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Address"
                v-model="formSchema.address"
                :rules="[v => !!v || 'Address is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Office Phone"
                v-model="formSchema.office_phone_no"
                :rules="[v => !!v || 'Office phone no is required !',phoneNum]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Office Fax"
                v-model="formSchema.office_fax"
                :rules="[v => !!v || 'Office fax no is required !', faxNum, lng30]"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Office Email"
                v-model="formSchema.office_email"
                :rules="email"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <template v-if="showForm">
      <v-btn v-if="(userRole.saveButton || userRole.updateButton) && viewPermission==0" color="success" @click="submitOperationActivities" :disabled="!valid">
        <v-icon>save</v-icon>
        {{addUpdateBtn}}
      </v-btn>
      <v-btn color="error" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="primary" @click="nextStep">
        Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
    </template>
    </v-card-actions>

    <v-card-title>
      <h2>Implementing Agency</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.dev_partner_name }}</td>
        <td class="text-xs-left">{{ props.item.dev_partner_type }}</td>
        <td class="text-xs-left">{{ props.item.in_short }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="viewDetails(props.item)" title="Detail">
              <v-icon color="teal">visibility</v-icon>
          </v-btn>

          <v-btn v-if="userRole.updateButton" icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn title="View" v-if="userRole.viewButton && userRole.updateButton<1" icon class="mx-0" @click="editItem(props.index, props.item,'view')">
            <v-icon color="teal">edit</v-icon>
          </v-btn>

          <v-btn v-if="userRole.deleteButton" icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import ServerPath from '../../../../server-path/server-path';
export default {
  data() {
    return {
      valid: true,
      e1: 0,
      is_activeVal: 1,

      showForm:false,
      viewPermission:0,
      queryData2: {
      impAgencyId: ""
      },
      email: [
        v => !!v || "Field is required",
        v =>
          /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "Enter valied e-mail"
      ],

      delete_id: "",
      row_index: "",
      dialog2: false,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      formSchema: {
        id: 0,
        dev_partner_name: "",
        office_phone_no: "",
        dev_partner_type: "",
        office_email: "",
        office_fax: "",
        in_short: "",
        address: ""
      },

      /*------------- Datatable ---------------*/
      serialNumber: 0,
      sort: "",
      queryData: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        search_val: ""
      },

      search: "",
      totalDesserts: 0,
      desserts: [],
      loading: true,
      pagination: {},

      headers: [
        {
          text: "SL",
          value: ""
        },
        {
          text: "Implementing Agency Name",
          align: "left",
          sortable: true,
          value: "dev_partner_name"
        },
        {
          text: "Implement Partner Type",
          align: "left",
          sortable: true,
          value: "dev_partner_type"
        },
        { text: "In Short", align: "left", sortable: true, value: "in_short" },
        {
          text: "Active",
          align: "left",
          sortable: true,
          value: "is_active"
        },
        { text: "Action", align: "center", value: "" }
      ]
      /*------------- /Datatable ---------------*/
    };
  },

  created()
  {
    sessionStorage.removeItem('dev_partner_id')
  },
  
  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    },

    userRole: function(){}
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;      
      return role;
    }
  },
  /*------------/Datatable------------*/

  methods: {
    viewDetails(item){ 
      sessionStorage.setItem("impAgencyId", item.id); 
      const impAgencyId = new Promise((resolve, reject) => {
          if(sessionStorage.getItem("impAgencyId")){
            resolve(sessionStorage.getItem("impAgencyId"))
          }else{
             reject('No id found')
          }
      });
       
        impAgencyId.then(res => {
          let query_Data2 = this.queryData2;
          
          (query_Data2.impAgencyId = res)
           console.log(query_Data2)

          let parameters = new URLSearchParams({ ...query_Data2}).toString();
          let route = ServerPath.serverPath+'/imp-agency-pdf?'+parameters;
          window.open(route, '_blank');
        })
        .catch(err => {
          console.log(err)
        })
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "implementing-agency-info")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    submitOperationActivities() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      this.$refs.loader.loaderEnabled();

      let $this = this;
      let formSchema = this.formSchema

      let func_name = 'insertFormData';
      if(formSchema.id>0)
      {
        func_name = 'updateFormData';
      }

      commonService[func_name](formSchema, "implementing-agency2")
        .then(res => {
          
          if (res.status == 1) {
            sessionStorage.setItem("dev_partner_id", res.data.id);
            if (res.action == "update") {
              this.$set(this.desserts, this.row_index, { ...res.data });
              this.showForm = this.userRole.saveButton
            } else {
              $this.desserts.unshift({ ...res.data });
            }            
            $this.close();

            window.scrollTo({
              left: 0,
              top:
                document.body.scrollHeight ||
                document.documentElement.scrollHeight,
              behavior: "smooth"
            });
            this.SnackbarVal.color = "success";
          } 
          else 
          {            
            this.SnackbarVal.color = "error"; 
          }

          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

        });
    },

    nextStep() {
      let devPId = sessionStorage.getItem("dev_partner_id")
      if(devPId){        
        this.$emit("emitForm1", 2);
      }
      else
      {
        this.SnackbarVal.color = "error";         
        this.SnackbarVal.message = "Select the row you want to edit.";
        this.SnackbarVal.snackbar = true;
      }
    },

    previous() {
      sessionStorage.removeItem('dev_partner_id');
      this.$emit("emitForm1", 1);
    },

    editItem(index, item, view='') { 

      if(view)
      {
        this.viewPermission = true;
      }
      this.showForm = true;

      sessionStorage.setItem("dev_partner_id", item.id);
      this.row_index = index;
      this.formSchema = { ...item };
      this.scrollPage(0, 100); //set top, left position value
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "implementing-agency2").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.SnackbarVal.color = "success";
        }
        else
        {          
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      this.viewPermission = false;
      sessionStorage.removeItem('dev_partner_id');
      this.formSchema.id = 0;
      this.$refs.form.reset();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/project_info/implement_agency/step_forms/implementingAgency.vue